import { useTLang } from 'intl/intl';

export function useMenuHeaderLang() {
  return {
    title: useTLang({ id: 'menuPage.header.title' }),
    filterBtn: useTLang({ id: 'menuPage.header.filterBtn' }),
    searcher: {
      placeholder: useTLang({ id: 'menuPage.header.searcher.placeholder' }),
    },
  };
}
